import React from "react";
import './loading.scss'



export const Loading = (props) => {
  return (
    <div className="loading">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
